<script>
import { mapGetters, mapActions } from 'vuex';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useAccount } from 'dashboard/composables/useAccount';
import Banner from 'dashboard/components/ui/Banner.vue';

export default {
  components: { Banner },
  setup() {
    const { isAdmin } = useAdmin();

    const { accountId } = useAccount();

    return {
      accountId,
      isAdmin,
    };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      uiFlags: 'accounts/getUIFlags',
    }),
    billing() {
      const account = this.getAccount(this.accountId);
      return account?.billing || {};
    },
    bannerMessage() {
      return this.$t('GENERAL_SETTINGS.PAYMENT_PENDING');
    },
    actionButtonMessage() {
      return this.$t('GENERAL_SETTINGS.UPDATE_PAYMENT');
    },
    shouldShowBanner() {
      if (!this.billing.enabled) {
        return false;
      }

      if (!this.isAdmin) {
        return false;
      }

      return this.billing.status === 'past_due';
    },
  },
  methods: {
    ...mapActions({
      openBillingPortal: 'accounts/checkout',
    }),
    updatePayment() {
      if (this.uiFlags.isCheckoutInProcess) return;

      this.openBillingPortal();
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="alert"
    :banner-message="bannerMessage"
    :action-button-label="actionButtonMessage"
    has-action-button
    @primary-action="updatePayment"
  />
</template>
